module.exports = __webpack_public_path__ + "static/huanghou-a3b2eece5a4b52897e7003586835fc3f.jpg";